import { Breakpoint, useTheme } from '@mui/material';

export const useIsMobile = (cb: Breakpoint) => {
  const theme = useTheme();

  return theme.breakpoints.values[cb] < theme.breakpoints.values['laptop'];
};
